import { render, staticRenderFns } from "./Markup.vue?vue&type=template&id=1c0cda3b"
import script from "./Markup.vue?vue&type=script&lang=js"
export * from "./Markup.vue?vue&type=script&lang=js"
import style0 from "./Markup.vue?vue&type=style&index=0&id=1c0cda3b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports